import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import axios from "axios";
import { checkComponentAvailability, styleToObj } from "../utils/functions";

import "./LandingPages.scss";

import Meta from "../components/meta/meta";
import MainBanner1Component from '../components/main-banner-1/main_banner_1';
import MainBanner2Component from '../components/main-banner-2/main_banner_2';
import WheelBannerComponent from '../components/wheel-banner/wheel_banner';
import NavBar1Component from '../components/nav-bar-1/nav_bar_1';
import RowBlocks1Component from '../components/row-blocks-1/row_blocks_1';
import GenericBlock1Component from '../components/generic-block-1/generic_block_1';
import TermsAndConditions1Component from "../components/terms-and-conditions-1/terms_and_conditions_1";
import CarouselComponent from "../components/carousel/carousel";
import FooterComponent from "../components/footer/footer";
import ShapeComponent from "../components/shape/shape";
import ImageComponent from "../components/image/image";
import YoutubeComponent from "../components/youtube_component/youtube_component";
import FullHtml from "../components/full-html/full-html";
import { clientId } from "../init";
import PlayerAbuseChecker from "../utils/PlayerAbuseChecker";

const empty = {};
const pac = PlayerAbuseChecker.getInfo();

const interceptClickEvent = (data) => (e) => {
  let target = e.target || e.srcElement;

  if (target.tagName !== 'A') {
    let tmp = target.closest("A");
    if (tmp && tmp.tagName === 'A') {
      target = tmp;
    }
  }

  if (target.tagName === 'A') {
    let href = target.getAttribute('href');
    if (!href.startsWith("http")) {
      return;
    }

    e.preventDefault();

    const search = window.location.search.replace("?", "");

    const params = [];
    if (data) {
      Object.keys(data).forEach(key => {
        if (key && data[key]) {
          params.push(`${key}=${encodeURIComponent(data[key])}`)
        }
      })
    }

    const hasDVFP = params.find((param) => param.indexOf("dvfp=") > -1);
    if (!hasDVFP) {
      params.push(`dvfp=${pac.dvfp}`);
    }
    const hasNWFP = params.find((param) => param.indexOf("nwfp=") > -1);
    if (!hasNWFP) {
      params.push(`nwfp=${pac.nwfp}`);
    }

    if (href.indexOf("?") > -1) {
      href = `${href}&${search ? search + "&" : ""}${params.join("&")}`;
    } else {
      href = `${href}?${search ? search + "&" : ""}${params.join("&")}`;
    }

    window.location.assign(href);
  }
};

const LadingPages = (props) => {
  const { landingPages, location } = props;

  const [pageData, setPageData] = React.useState(null);
  const lang = "ro";

  const [form, setForm] = React.useState({
    name: "",
    phone: "",
  });

  React.useEffect(() => {
    let mounted = true;
    if (landingPages && Object.keys(landingPages).length > 0) {
      let path = location.pathname;
      if (path[path.length - 1] === "/") {
        path = path.slice(0, -1);
      }

      if (typeof landingPages[path] !== "undefined") {
        const moid = landingPages?.[path]?.settings?.moid;

        let skipML = false;
        try {
          const uri = new URL(window.location.href);
          if (uri.searchParams.has("skipML")) {
            skipML = uri.searchParams.get("skipML") === "1" || uri.searchParams.get("skipML") === "true";
          }
        } catch (e) {/* */ }

        if (!skipML && window.ini.USE_ML[clientId] === "true" && window.ini.ML_API_URL && moid) {
          //  'http://ml-lpo-dev.gambling-solutions.ro/landingPages/v1/clients/2/offers/d9784c94b9d5a85bd9cde850886c4ee6c808e835?dvfp=7937c4d2371b17dfe2d0e991d26288de' \
          axios.get(`${window.ini.ML_API_URL}/clients/${clientId}/offers/${moid}?dvfp=${pac.dvfp}`).then((response) => {
            if (mounted) {
              const lpid = response.data.lpid;

              if (lpid) {
                const exists = Object.keys(landingPages).find((key) => {
                  return landingPages[key].lpid === lpid;
                });

                if (exists) {
                  setPageData(landingPages[exists]);
                  return;
                }
              }

              setPageData(landingPages[path]);
            }
          }).catch((error) => {
            console.error("Error fetching ml landing page data:", error);
            setPageData(landingPages[path]);
          });
        } else {
          setPageData(landingPages[path]);
        }
      } else {
        if (window.ini.CLIENTS_DOMAIN?.[clientId]) {
          window.location.assign(`https://${window.ini.CLIENTS_DOMAIN?.[clientId]}/`);
        }
      }
    }

    return () => {
      mounted = false;
    }
  }, [landingPages, location]);

  React.useEffect(() => {
    let interceptClickEventCB = null;
    if (pageData) {
      const data = {
        moid: pageData && pageData.settings && pageData.settings.moid ? pageData.settings.moid : "",
        lpid: pageData && pageData.lpid ? pageData.lpid : "",
        name: form && form.name ? form.name : "",
        phone: form && form.phone ? form.phone : "",
        email: form && form.email ? form.email : "",
        emailYahoo: form && form.emailYahoo ? form.emailYahoo : "",
      }

      interceptClickEventCB = interceptClickEvent(data);
      document.addEventListener("click", interceptClickEventCB, false);
    }
    return () => {
      if (interceptClickEventCB) document.removeEventListener("click", interceptClickEventCB, false);
    };
  }, [pageData, form]);

  if (!pageData) return null;

  const components = [];
  let pageStyle = empty;

  if (typeof pageData.meta !== "undefined") {

    const settings = pageData.settings ? pageData.settings : null;
    if (settings && settings.meta && Object.keys(settings.meta).length > 0) {
      components.push(<Meta key="meta" meta={settings.meta} />);
    }

    pageData.meta.forEach((data, index) => {
      if (!checkComponentAvailability(data)) return;

      if (data.type === "main_banner_1") {
        components.push(<MainBanner1Component key={index} index={index} data={data} lang={lang} />);
      } else if (data.type === "main_banner_2") {
        components.push(<MainBanner2Component key={index} index={index} data={data} lang={lang} form={form} setForm={setForm} />);
      } else if (data.type === "wheel_banner") {
        components.push(<WheelBannerComponent key={index} index={index} data={data} lang={lang} form={form} setForm={setForm} />);
      } else if (data.type === "nav_bar_1") {
        components.push(<NavBar1Component key={index} index={index} data={data} lang={lang} />);
      } else if (data.type === "row_blocks_1") {
        components.push(<RowBlocks1Component key={index} index={index} data={data} lang={lang} />);
      } else if (data.type === "generic_block_1") {
        components.push(<GenericBlock1Component key={index} index={index} data={data} lang={lang} />);
      } else if (data.type === "terms_and_conditions_1") {
        components.push(<TermsAndConditions1Component key={index} index={index} data={data} lang={lang} />);
      } else if (data.type === "carousel") {
        components.push(<CarouselComponent key={index} index={index} data={data} lang={lang} />);
      } else if (data.type === "footer") {
        components.push(<FooterComponent key={index} index={index} data={data} lang={lang} />);
      } else if (data.type === "shape") {
        components.push(<ShapeComponent key={index} index={index} data={data} lang={lang} />);
      } else if (data.type === "image") {
        components.push(<ImageComponent key={index} index={index} data={data} lang={lang} />);
      } else if (data.type === "youtube_component") {
        components.push(<YoutubeComponent key={index} index={index} data={data} lang={lang} />);
      } else if (data.type === "full_html") {
        components.push(<FullHtml key={index} index={index} data={data} lang={lang} />);
      }
    });

    pageStyle = styleToObj(pageData.settings && pageData.settings.style ? pageData.settings.style : empty);
  }

  return (
    <div className="page-wrapper" style={pageStyle}>
      {components}
    </div>
  );
}
const nullRef = null;
const mapProps = (state, props) => {
  return {
    landingPages: state.lp && state.lp.app && state.lp.app.landingPages ? state.lp.app.landingPages : nullRef
  }
}

export default withRouter(connect(mapProps)(LadingPages));